/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-block-headlines';
import './content-block-headlines-heading';
import './content-block-headlines-item';
import '../content-block/content-block-copy';
import '../content-block/content-block-heading';
import '../content-item/content-item-copy';
import '../cta/link-list-item-cta';
